import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import { Card, Page, FTBody } from '../Fuse';
import icspPlatform from './ICSP-Platform.png';
import ConsoleStore from '../../stores/ConsoleStore';

import './ConsolePolicyAPI.css';

const block = b.lock('ConsolePolicyAPI');

class ConsolePolicyAPI extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
    };

    render() {
        const URLS = {
            swagger: '/swagger-ui/index.html?configUrl=%2Fv3%2Fapi-docs%2Fswagger-config&urls.primaryName=policies',
            platform: this.props.console.platformUrl,
            doc: 'https://proofpointcommunities.force.com/community/s/article/Latest-Proofpoint-Isolation-Documentation'
        };
        return <Page title="Product Settings - Policy API" className={block()}>
            <Card title="What is the Policy API?">
                <FTBody className={block('Paragraph')}>
                    The Policy API allows you to create Isolation Policies (Rules, Roles, and Custom Categories).
                    These are the same APIs that Proofpoint
                    Isolation Console uses to manage its User Interface, therefore you need to be
                    familiar with how Isolation Policies work in order to use
                    the Policy API.
                </FTBody>
                <FTBody className={block('Paragraph')}>
                    Isolation’s Policy API tools and documentation are available via the
                    <a className={block('Link')} href={URLS.swagger} target="_blank"> Swagger UI</a>.
                </FTBody>
                <FTBody className={block('Paragraph')}>
                    For security purposes, you will need to first configure access
                    credentials in the Developer application (located in Proofpoint’s
                    Information and Cloud Security Platform).
                </FTBody>
                <img className={block('Img')} src={icspPlatform} alt="Platform - Develop Menu"/>
                <FTBody className={block('Paragraph')}>
                    The key steps to using the Policy API are:
                </FTBody>
                <ul className={block('HeadingUl')}>
                    <li>
                        <FTBody>
                            Access the ’Developer Application’ available through the App Switcher
                        </FTBody>
                    </li>
                    <li>
                        <FTBody>Generate Authorization Credentials</FTBody>
                    </li>
                    <li>
                        <FTBody>
                            Write a Script or Client Application against Isolation API to configure policies
                        </FTBody>
                    </li>
                </ul>
                <FTBody className={block('Heading')}>
                    Prerequisites
                </FTBody>
                <FTBody className={block('Paragraph')} >
                    You are an IT professional with a pre-existing knowledge of and access to the following:
                </FTBody>
                <ul className={block('HeadingUl')}>
                    <li>
                        <FTBody>Isolation’s Policies</FTBody>
                    </li>
                    <li>
                        <FTBody>How to use APIs that are delivered as REST formatted APIs</FTBody>
                    </li>
                    <li>
                        <FTBody>
                            Your organization’s Proofpoint Information and Cloud Security Platform services
                        </FTBody>
                    </li>
                </ul>
                <FTBody className={block('Heading')}>
                    Best Practices
                </FTBody>
                <FTBody className={block('Paragraph')}>
                    When starting out, we recommend you begin using the Policy API with a sandbox lab tenant.
                    This allows you to begin using the Policy API
                    without impacting your production environment.
                </FTBody>
                <FTBody className={block('Paragraph')}>
                    For detailed instructions, please refer to our
                    <a className={block('Link')} href={URLS.doc} target="_blank">
                        &nbsp;Policy API guide
                    </a>.
                </FTBody>
            </Card>
        </Page>;
    }
}

export default inject('console')(observer(ConsolePolicyAPI));
